import React from "react";

// core components
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { Grid } from "@mui/material";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useWatch } from "react-hook-form";

function Roles() {
  const id = useWatch({ name: "id" });
  return (
    <Card>
      <CardBody>
        <Grid>
          <FormAsyncTC
            async={{
              url: "core/roles/search?fields=id as value, name as label&per_page=50",
              searchField: "name",
            }}
            id={"roles" + id}
            multiple={true}
            name={"roles"}
            primaryKey={"name"}
            tKey={"Kies een Role"}
          />
        </Grid>
      </CardBody>
    </Card>
  );
}

export default Roles;
